import { UserResult } from "services/accountService/models/AccountType";
import { CourseDetailsResult } from "services/courseService/models/CourseType";
import {
  ScientificClassificationResult,
  ScientificSpecializationResult,
} from "services/scientificPublicationsService/models/scientificPublicationsTypes";
import { CentreManagementDetailsResult, FileResult } from "services/shared-models/sharedTypes";
import {LookupResult} from "../../lookupService/models/LookupsType";
import {ExaminerListResult} from "../../examinersService/Model/ExaminerTypes";
import {RefereeListResult} from "../../RefereeService/Model/RefereeTypes";

export type ReturnCourseOrderRequest = {
  actionName: string;
  serialGuid: string; // Guid in C# is represented as a string in TypeScript
  selectedCourseOrderExaminers: SelectedCourseOrderExaminerRequest [];
  notes?: string | null; // Nullable string in C# is represented as optional or null in TypeScript
  activityGuid?: string | null; // Nullable Guid in C# is represented as optional or null in TypeScript
};

export type ReturnCourseOrderRefereeRequest = {
  actionName: string;
  serialGuid: string;
  selectedCourseOrderReferees: SelectedCourseOrderRefereeRequest[];
  notes?: string | null;
  activityGuid?: string | null;
};

export type SelectedCourseOrderExaminerRequest = {
  courseOrderExaminerId: number;
  showFiles: boolean;
  showRecommendation: boolean;
};

export type SelectedCourseOrderRefereeRequest = {
  courseOrderRefereeId: number;
  showFiles: boolean;
  showRecommendation: boolean;
};

export type CourseOrderResult = {
  id: number;
  courseId: number;
  centreManagementId?: number |null;
  formSubject: string;
  formValue: string;
  isAcceptedConditionAndRules: boolean;
  isAcceptedCommitments: boolean;
  appliedDate: Date;
};

export type CreateCourseOrderRequest = {
  scientificSpecializationValue?:string |null;
  courseId: number;
  typeOfScientificCategoryId:number;
  appliedProcessInstanceId?: number;
  formValue?: string;
  centreManagementId?: number |null;
  publishingOrderTypeId?: number |null;
  scientificSpecializationId: number;
  languageOfScientificId: number;
  typeOfScientificId: number;
  scientificClassificationId: number;
  numberOfPages: number;
  acceptTermsAndCondition: boolean;
  acceptAmendments: boolean;
  researcherAttachmentIds: string[];
  researcherAttachmentWithoutInfoIds: string[];
  researcherNotes?: string;
  notes?: string;
  isDraft: boolean;
  serialGuid?: string | null;
  actionName?: string | null;
  activityGuid?: string | null;
  actionsFileIds?:string[]
};

export type TypeOfScientificResult = {
  id: number;
  typeOfScientificDetail: TypeOfScientificDetailsResult;
};

export type TypeOfScientificDetailsResult = {
  displayName: string;
  locale: string;
};

export type ScientificClassificationDetailsResult = {
  displayName: string;
  locale: string;
};

export type CourseOrderLocalResult = {
  id: number;
  courseId: number;
  courseSerialNumber: string;
  serialNumber: string;
  numberOfPages: number;
  courseDetail: CourseDetailsResult;
  typeOfScientific: TypeOfScientificResult;
  typeOfScientificCategory: LookupResult;
  scientificClassification: ScientificClassificationResult;
  appliedUser: UserResult;
  createdOn: Date;
  centreManagementDetail: CentreManagementDetailsResult;
  centreManager: UserResult;
  courseOrderPhase: string;
  courseOrderStatusId: number;
  courseOrderStatus: string;
  orderType : string;
};


export type LanguageOfScientificResult = {
  id: number;
  languageOfScientificDetail: LanguageOfScientificDetailsResult;
};

export type LanguageOfScientificDetailsResult = {
  displayName: string;
  locale: string;
};
export type UpdateCenterManagerRequest={
    centreManagementId?:number|null;
    workFlowTaskRequest?:WorkFlowTaskRequest;
}
export  type  WorkFlowTaskRequest={
    actionName:string;
    notes:string;
    serialGuid:string;
    activityGuid:string;
}
export type CourseOrderLocalItemResult = {
  id: number;
  courseId: number;
  scientificSpecializationValue?:string;
  typeOfScientificCategoryId:number;
  serialNumber: string;
  courseOrderStatusId: number;
  courseOrderStatus: string;
  processInstanceId: number;
  submissionDate: string;
  notes: string;
  isInspectMode: boolean;
  researcherNotes: string;
  numberOfPages: number;
  acceptTermsAndCondition: boolean;
  acceptAmendments: boolean;
  centreManagementId?: number |null;
  courseOrderEvaluation: CourseOrderEvaluationResult;
  centreManagement: CentreManagementDetailsResult;
  researcherAttachment: FileResult[];
  researcherAttachmentWithoutInfo: FileResult[];
  appliedUser: UserResult;
  formValue: string;
  scientificSpecialization: ScientificSpecializationResult;
  languageOfScientific: LanguageOfScientificResult;
  typeOfScientific: TypeOfScientificResult;
  typeOfScientificCategory: LookupResult;
  scientificClassification: ScientificClassificationResult;
  isbn?: string;
  isbnRequestedDate?: string;
  isbnFiles: FileResult[];
  isbnContractId?: string;
  isbnContract?: FileResult;
  authorAmount?: number;
  authorAmountFiles: FileResult[];
  selectedCourseOrderExaminers:SelectedCourseOrderExaminerResult[];
  selectedCourseOrderReferees:SelectedCourseOrderRefereeResult[];
  publishingOrderType: PublishingOrderTypeResult;
  currentExaminerIteration :number;
  courseOrderExaminerIterations: CourseOrderExaminerIterationResult [] ;
  courseOrderRefereeIterations: CourseOrderRefereeIterationResult[] ;
  currentRefereeIteration: number;
}


export type CourseOrderRefereeIterationResult= {
    id:number;
    evaluationForm: EvaluationFormResult;
    evaluationFormId?: number; // Nullable int is represented as an optional number in TypeScript
    iteration: number;
    files: FileResult[]; // ICollection<FileResult> is represented as an array of FileResult in TypeScript
    courseOrderIterationFileHistories: CourseOrderIterationFileHistoryResult[]; // ICollection<CourseOrderIterationFileHistoryResult> is represented as an array of CourseOrderIterationFileHistoryResult in TypeScript
}
export type CourseOrderExaminerIterationResult={
    id:number;
    evaluationForm: EvaluationFormResult;
    evaluationFormId?: number; // Nullable int is represented as an optional number in TypeScript
    iteration: number;
    files: FileResult[]; // ICollection<FileResult> is represented as an array of FileResult in TypeScript
    courseOrderIterationFileHistories: CourseOrderIterationFileHistoryResult[]; // ICollection<CourseOrderIterationFileHistoryResult> is represented as an array of CourseOrderIterationFileHistoryResult in TypeScript
}

export type CourseOrderIterationFileHistoryResult={
    id:number;
    courseOrderExaminerIterationId?: number;
    courseOrderRefereeIterationId?: number;
    actionType: string;
    files: FileResult[];
    createdOn?: Date | null;
}

export type SelectedCourseOrderExaminerResult = {
  courseOrderExaminerId: number;
  courseOrderId: number;
  showRecommendation: boolean;
  showFiles: boolean;
  courseOrderExaminer: ExaminerListResult;
};
export type SelectedCourseOrderRefereeResult = {
  courseOrderRefereeId: number;
  courseOrderId: number;
  showRecommendation: boolean;
  showFiles: boolean;
  courseOrderReferee: RefereeListResult;
};

export interface PublishingOrderTypeDetailsResult {
  displayName: string;
  locale: string;
}

export interface PublishingOrderTypeResult {
  id: number;
  publishingOrderTypeDetail: PublishingOrderTypeDetailsResult;
}

export type CourseOrderEvaluationResult = {
  id: number;
  evaluationForm: EvaluationFormResult;
  currentIteration: number;
  currentRefereeIteration: number;
  evaluationFormId?: number; // Nullable int is represented as an optional number in TypeScript
  refereeEvaluationForm: EvaluationFormResult;
  refereeEvaluationFormId?: number; // Nullable int is represented as an optional number in TypeScript
  files: FileResult[]; // ICollection<FileResult> is represented as an array of FileResult in TypeScript
  refereeFiles: FileResult[]; // ICollection<FileResult> is represented as an array of FileResult in TypeScript
};

type EvaluationFormResult ={
    id: number;
    evaluationFormDetail: EvaluationFormDetailResult;
}

type EvaluationFormDetailResult ={
    displayName: string;
    locale: string;
}
export const CourseOrderStatus = {
  Pending: {
    id: 1,
    label: "Pending", // TODO: check
    color: "primary",
  },
  Completed: {
    id: 2,
    label: "Completed",
    color: "success",
  },
  Rejected: {
    id: 3,
    label: "Rejected",
    color: "danger",
  },
  Draft: {
    id: 4,
    label: "Draft",
    color: "secondary",
  },
};

// Type definition for ActivityResult
export interface ActivityResult {
  activityGid: string; // Using string to represent GUID in TypeScript
  activityName?: string | null; // Optional and nullable
}


export interface CourseOrderActionResult {
  action: string;
  processInstanceId: number; // long in C# maps to number in TypeScript
  folio?: string | null;
  workflowName?: string | null;
  appliedBy: UserResult;
  createdOn?: Date | null; // DateTimeOffset in C# maps to Date in TypeScript
  status?: string | null;
  notes?: string | null;
  activity?: ActivityResult | null;
  attachments: FileResult[];
}

export  type UpdateCourseEvaluationOrderRequest={
    evaluationFormId:number;
    filesIds:string[];
}

export type UpdateCourseOrderISBNRequest= {
  iSBN?: string ;
  iSBNRequestedDate?: Date |null
  iSBNFiles?: string[] ;
  iSBNContractId?: string
}
export type UpdateCourseOrderAmountRequest ={
  authorAmount?: number;
  authorAmountFiles: string[];
}